var map = {
	"./1.png": 5024,
	"./10.png": 4242,
	"./2.png": 8843,
	"./3.png": 8338,
	"./4.png": 61,
	"./5.png": 8932,
	"./6.png": 4047,
	"./7.png": 8854,
	"./8.png": 369,
	"./9.png": 9240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6814;